import EventDispatcher from "../common/EventDispatcher";
import * as THREE from 'three';
import {
    Global
} from "../common/global";

export default class GameControl {
    constructor(scene) {
        this.scene = scene;
    }

    init() {
        this.events = EventDispatcher.getObj();
        this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));
        this.events.addEventListener("GAME_EVENTS", this.onEvents.bind(this));
        this.events.addEventListener("LOADER_EVENTS", this.onEvents.bind(this));

        this.directions = [];

        // Add touch event listeners
        this.touchStartX = null;
        this.touchStartY = null;
        this.isTouching = false;
        this.lastDeltaX = 0;

        // Touch events
        document.addEventListener('touchstart', this.onTouchStart.bind(this, true));
        document.addEventListener('touchmove', this.onMove.bind(this, true));
        document.addEventListener('touchend', this.onTouchEnd.bind(this));

        // Mouse events for desktop
        document.addEventListener('mousedown', this.onTouchStart.bind(this, false));
        document.addEventListener('mousemove', this.onMove.bind(this, false));
        document.addEventListener('mouseup', this.onTouchEnd.bind(this));

        this.swipeX = -1;
        this.middleInitX = -1;
        this.leftLimit = 0;
        this.rightLimit = 0;
        this.extraSwipeFact = 0;
        this.canSwipe = false;
    }

    // Touch event handlers
    onTouchStart(isTouchEvent, event) {
        if (!this.canSwipe) return false;

        // if(Global.introActive){
        //     this.events.dispatchEvent({
        //         type: "GAMESCENE_EVENTS",
        //         message: {
        //             "event_type": "hide_screen",
        //             data: {
        //                 'screenKey':'Intro'
        //             }
        //         }
        //     });
        // }

        this.touchStartX = isTouchEvent ? event.touches[0].clientX : event.clientX;
        this.touchStartY = isTouchEvent ? event.touches[0].clientY : event.clientY;
        this.isTouching = true;
        this.starGr.visible = true;
    }

    onMove(isTouchEvent, event) {
        if (!this.isTouching) return;
        if (!this.canSwipe) return false;

        const touchEndX = isTouchEvent ? event.touches[0].clientX : event.clientX;
        const touchEndY = isTouchEvent ? event.touches[0].clientY : event.clientY;

        this.handleMove(touchEndX, touchEndY);
    }

    onTouchEnd() {
        if (!this.canSwipe || !this.isTouching) return false;

        this.isTouching = false;
        this.touchStartX = null;
        this.touchStartY = null;



        // alert(this.swipeX-this.initSwipeX)
        this.starGr.visible = false;


        this.events.dispatchEvent({
            type: "PLAYER_EVENTS",
            message: {
                "event_type": "kick_ball",
                data: {}
            }
        });


        this.disableSWipe();
    }
    launchBall() {
        this.events.dispatchEvent({
            type: "GAMESCENE_EVENTS",
            message: {
                "event_type": "launch_ball",
                data: {
                    'curve_fact': this.swipeX - this.initSwipeX, //endPoint.x-middlePoint.x,
                    'swipeDir': Math.sign(this.swipeX)
                }
            }
        });
    }


    // Common logic for handling movement
    handleMove(endX, endY) {
        const deltaX = endX - this.touchStartX;
        const deltaY = endY - this.touchStartY;

        const canUpdateStart = this.updateMiddlePoint(deltaX * 1.5, deltaY);

        this.touchStartX = endX;
        this.touchStartY = endY;

    }
    updateMiddlePoint(deltaX, deltaY) {
        const sensitivity = 0.02;

        // Update swipeX based on the deltaX input
        this.swipeX += deltaX * sensitivity;

        const middlePoint = Global.ballPath.points[2]; // Middle point is at index 2
        const endPoint = Global.ballPath.points[4]; // End point is at index 4

        // Clamp middlePoint.x within the allowed range
        middlePoint.x = this.swipeX;
        middlePoint.x = Math.min(this.leftLimit, middlePoint.x);
        middlePoint.x = Math.max(this.rightLimit, middlePoint.x);

        // if(middlePoint.x==.4 || middlePoint.x>=-3)
        // Calculate the endPoint.x based on the swipeX and middlePoint.x
        const canCrossMiddle = false;
        const xPadd = this.swipeX - (-this.middleInitX + (this.swipeX)) * 0.25 - (this.swipeX - middlePoint.x) * 2
        endPoint.x = xPadd;
        const midpointLocked = middlePoint.x !== this.swipeX

        // Restrict endPoint.x if the difference between middlePoint.x and endPoint.x is more than 2
        const maxDifference = (1.5 + Math.abs(Global.xPadd * .5) * (Math.sign(middlePoint.x - endPoint.x) !== Math.sign(Global.xPadd) ? 0 : 1));
        const difference = Math.abs(middlePoint.x - endPoint.x);

        if (difference > maxDifference && midpointLocked) {
            if (endPoint.x > middlePoint.x) {
                endPoint.x = middlePoint.x + maxDifference;
            } else {
                endPoint.x = middlePoint.x - maxDifference;
            }
            if (Math.sign(this.lastDeltaX) !== Math.sign(deltaX) && Math.abs(deltaX) !== 0) {
                this.swipeX -= this.extraSwipeFact;
                this.extraSwipeFact = 0;
            }
            this.extraSwipeFact += deltaX * sensitivity;
        }
        this.lastDeltaX = deltaX;

        // Adjust the control points for smoother curves
        this.adjustPoints(true);
    }

    adjustPoints(updateShootDirection) {
        const startPoint = Global.ballPath.points[0]; // Start point is at index 0
        const controlPoint1 = Global.ballPath.points[1]; // Control point 1 is at index 1
        const middlePoint = Global.ballPath.points[2]; // Middle point is at index 1
        const controlPoint2 = Global.ballPath.points[3]; // Control point 2 is at index 3
        const endPoint = Global.ballPath.points[4]; // Control point 2 is at index 3

        if (updateShootDirection) {
            if (endPoint.x >= middlePoint.x/* Global.keeperX */) {
                Global.shootDirection = "Left"
            } else {
                Global.shootDirection = "Right"
            }
        }

        // Calculate control points using linear interpolation
        const t1 = 0; // Interpolation factor for controlPoint1
        const t2 = 1; //0.98; // Interpolation factor for controlPoint2

        controlPoint1.x = startPoint.x + (middlePoint.x - startPoint.x) * t1;
        controlPoint1.y = startPoint.y + (middlePoint.y - startPoint.y) * t1;
        controlPoint1.z = startPoint.z + (middlePoint.z - startPoint.z) * t1;



        controlPoint2.x = middlePoint.x + (endPoint.x - middlePoint.x) * t2;
        controlPoint2.y = middlePoint.y + (endPoint.y - middlePoint.y) * t2;
        controlPoint2.z = middlePoint.z + (endPoint.z - middlePoint.z) * t2;


        // Update the ball path with the new points
        Global.ballPath = new THREE.CatmullRomCurve3(Global.ballPath.points);
        Global.ballPath.curveType = 'chordal';
        Global.ballPath.tension = 0.5;

        // Update the positions of the stars along the path
        this.curvePoints = Global.ballPath.getSpacedPoints(30 + Math.abs(Global.xPadd) * 2);

        let lastFound = false
        this.curvePoints.forEach((point, index) => {
            if (!this[`star${index + 1}`]) {
                this[`star${index+1}`] = new THREE.Mesh(this.starGeometry, this.starMaterial);
                this.starGr.add(this[`star${index+1}`]);
            }


            let scaleFact = 0.6 + index * 0.04 * 1.75;
            scaleFact = Math.min(2.0, scaleFact)
            this[`star${index + 1}`].position.copy(point);
            this[`star${index + 1}`].position.z += .15
            this[`star${index + 1}`].position.z -= .25;
            this[`star${index + 1}`].scale.set(scaleFact, scaleFact, scaleFact);
            this[`star${index + 1}`].lookAt(new THREE.Vector3(point.x, point.y - 2, point.z));

            if (lastFound) {
                this[`star${index+1}`].visible = false;
            } else {
                this[`star${index+1}`].visible = true;
            }
            if (point.z >= -1) lastFound = true;
        });
    }
    resetCurvePoints(data) {
        const {
            x,
            y,
            z
        } = data.position;

        // Fixed end point
        this.middleInitX = -1 - Global.xPadd * 1.25; //(data.position.x);
        this.initSwipeX = -1 + Global.xPadd * .25
        this.swipeX = -1 + Global.xPadd * .25 //(data.position.x);//(data.position.x - 1)/2
        this.leftLimit = .8 -.5 + Global.xPadd / (Math.sign(Global.xPadd) == 1 ? 2.5 : 8) + 0.2;
        this.rightLimit = -3 + .5+ Global.xPadd / (Math.sign(Global.xPadd) == 1 ? 8 : 2.5) - 0.2;
        const endPoint = new THREE.Vector3(-1, 1.2 - 0.05, 0.7);

        // Calculate intermediate points dynamically
        const t1 = 0.5; // Interpolation factor for the first intermediate point
        const t2 = 0.9; // Interpolation factor for the second intermediate point
        const t3 = .75; // Interpolation factor for the third intermediate point



        /* 
                this.leftLimit = .8 + Global.xPadd / (Math.sign(Global.xPadd) == 1 ? 2.5 : 8) - 0.5*(x>-1?-1:1);
        this.rightLimit = -3 + Global.xPadd / (Math.sign(Global.xPadd) == 1 ? 8 : 2.5) + 0.5*(x>-1?1:-1);
        */

        const intermediatePoint1 = new THREE.Vector3(
            x + (endPoint.x - x * .7) * t1,
            y + (endPoint.y - y * .7) * t1,
            z + (endPoint.z - z * .7) * t1
        );

        const intermediatePoint2 = new THREE.Vector3(
            x + (endPoint.x - x * .7) * t2,
            y + (endPoint.y - y * .7) * t2,
            z + (endPoint.z - z * .7) * t2
        );

        const intermediatePoint3 = new THREE.Vector3(
            x + (endPoint.x - x) * t3,
            y + (endPoint.y - y) * t3,
            z + (endPoint.z - z) * t3
        );

        // Define the scaledPoints array with dynamic intermediate points
        const scaledPoints = [
            new THREE.Vector3(x, y, z), // Start point (from data.position)
            intermediatePoint1, // First intermediate point
            intermediatePoint2, // Second intermediate point
            intermediatePoint3, // Third intermediate point
            endPoint // Fixed end point
        ];

        // Update the ball path
        Global.ballPath = new THREE.CatmullRomCurve3(scaledPoints);
        Global.ballPath.curveType = 'catmullrom';
        Global.ballPath.tension = 0.5;

        // Update the trail texture and curve points
        const trailTexture = Global.assets['textures']['trail']['asset'];
        trailTexture.colorSpace = THREE.SRGBColorSpace;

        this.curvePoints = Global.ballPath.getSpacedPoints(50);

        // Initiize star geometry and material
        this.starGeometry = new THREE.PlaneGeometry(0.2, 0.2);
        this.starMaterial = new THREE.MeshBasicMaterial({
            map: trailTexture,
            transparent: true,
            side: THREE.DoubleSide
        });

        // Adjust the points to update the visual representation

        this.starGr.visible = false;

        this.updateMiddlePoint(0)
        this.adjustPoints(false);
    }

    initiateControls() {
        if (!this.starGr) {
            this.starGr = new THREE.Group()
            this.scene.add(this.starGr);
        }

    }

    onEvents(data) {
        switch (data['message']['event_type']) {
            case "create_scene":
                this.initiateControls();
                break;
            case "assign_position":
                this.resetCurvePoints(data['message']['data']);
                this.enableSwipe();
                break;
            case "ready_to_launch":
                this.launchBall();
                break;
            case "start_game":
                this.gameStarted = true;
                this.gameOver = false;
                break;
            case "update":
                this.update();
                break;
            case "enable_control":
                this.enableSwipe();
                break;
            case "disable_control":
                this.disableSWipe();
                break;
            case "game_over":
            case "disable_control":
                this.gameOver = true;
                Global.gameOver = true;
                this.gameStarted = false;
                this.stopDragging();
                this.directions = [];
                break;
            case "dispose":
                this.dispose();
        }
    }
    dispose() {
        this.curvePoints.forEach((point, index) => {
            this[`star${index+1}`].visible = false;
        });
    }
    enableSwipe() {
        this.canSwipe = true;
    }
    disableSWipe() {
        this.canSwipe = false;
    }

    update(dt) {}
}